import { HStack } from '@pets-ui/HStack/HStack'
import { Info } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  root: {
    margin: '0 -4px',
    padding: 4,
    alignItems: 'center',
    backgroundColor: {
      ':hover': colors.grey100,
    },
    display: 'flex',
  },
  infoIcon: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  clickable: {
    cursor: 'pointer',
  },
})

export interface FooterReminderListItemProps {
  title?: string
  stock?: number
  onClick?: () => void
}

export const FooterReminderListItem = (props: FooterReminderListItemProps) => {
  const { title, stock = 0, onClick } = props

  return (
    <div {...stylex.props(styles.root, !!onClick && styles.clickable)} onClick={onClick}>
      <HStack gap={1} mr={2} flexWrap="nowrap" alignItems="center" width={74} flexShrink={0}>
        <div {...stylex.props(styles.infoIcon)}><Info color={colors.red400} /></div>
        <Text color={colors.red400}>
          {stock <= 0 ? '缺貨' : '部分缺貨'}
        </Text>
      </HStack>
      <Text>{title}</Text>
    </div>
  )
}
